(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/animated-columns.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/animated-columns.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Icon = svs.ui.ReactIcon;
const Header = svs.playerRegistration.components.Header;
const FadeInSlideWrapper = svs.playerRegistration.components.FadeInSlideWrapper;


const animateShowHide = function () {
  let onComplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
  const gsapElasticOut = top => ({
    top,
    duration: 2,
    ease: 'elastic.out'
  });
  const initTimeline = onComplete => gsap.timeline({
    onComplete,
    paused: true
  });
  const tl0 = initTimeline(onComplete);
  const tl1 = initTimeline(onComplete);
  const tl2 = initTimeline(onComplete);
  tl0.set('#player-registration-col-1', {
    top: '100%'
  });
  tl0.set('#player-registration-col-2', {
    top: '100%'
  });
  tl0.set('#player-registration-col-3', {
    top: '100%'
  });
  tl0.set('#player-registration-icon-1', {
    opacity: 0
  });
  tl0.set('#player-registration-icon-2', {
    opacity: 0
  });
  tl0.set('#player-registration-icon-3', {
    opacity: 0
  });
  tl0.to('#player-registration-col-1', gsapElasticOut('52%'));
  tl0.to('#player-registration-col-2', gsapElasticOut('43%'), '<');
  tl0.to('#player-registration-col-3', gsapElasticOut('34%'), '<');
  tl0.to('#player-registration-icon-1', {
    opacity: 1,
    duration: 1
  }, '-=1.5');
  tl0.to('#player-registration-icon-2', {
    opacity: 1,
    duration: 1
  }, '<');
  tl0.to('#player-registration-icon-3', {
    opacity: 1,
    duration: 1,
    backgroundColor: 'transparent'
  }, '<');
  tl1.set('#player-registration-col-1', {
    top: '52%'
  });
  tl1.set('#player-registration-col-2', {
    top: '43%'
  });
  tl1.set('#player-registration-col-3', {
    top: '34%'
  });
  tl1.set('#player-registration-icon-3', {
    backgroundColor: 'transparent'
  });
  tl1.to('#player-registration-icon-3', {
    backgroundColor: '#6218FF',
    duration: 0.10,
    ease: 'power2.out'
  }, '<');
  tl2.set('#player-registration-icon-3', {
    backgroundColor: 'transparent'
  });
  tl2.to('#player-registration-col-2', {
    border: '2px',
    top: 0,
    duration: 1,
    ease: 'power2.out'
  }, '<');
  return {
    forward: [() => {
      tl0.play(0);
    }, () => {
      tl0.progress(1);
      tl1.play(0);
    }, () => {
      tl1.progress(1);
      tl2.play(0);
    }],
    back: [() => {
      tl2.kill();
      tl1.reverse();
    }, () => {
      tl2.reverse();
    }]
  };
};
const ColumnWrapper = _ref => {
  let children = _ref.children;
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-center",
    style: {
      padding: 80
    }
  }, React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-border-bottom-4"
  }, children));
};
const ColumnFrame = _ref2 => {
  let children = _ref2.children;
  return React.createElement("div", {
    className: "u-border-2 margin-h-1 u-flex u-flex-column",
    style: {
      marginBottom: -2,
      borderRadius: '4.8px 4.8px 0 0',
      height: 200,
      width: 53,
      overflow: 'hidden',
      position: 'relative'
    }
  }, children);
};
const Column = _ref3 => {
  let id = _ref3.id,
    _ref3$icon = _ref3.icon,
    icon = _ref3$icon === void 0 ? 'checkmark' : _ref3$icon;
  return React.createElement("div", {
    className: "bg-navy",
    id: "player-registration-col-".concat(id),
    style: {
      width: '100%',
      height: '100%',
      top: '99%',
      position: 'absolute'
    }
  }, React.createElement("div", {
    className: "padding-v",
    id: "player-registration-icon-".concat(id)
  }, React.createElement("div", null, React.createElement(Icon, {
    color: "icon-inverted",
    icon: icon,
    size: 400
  }))));
};
const AnimatedColumns = () => {
  const _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    step = _React$useState2[0],
    setStep = _React$useState2[1];
  const _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    animation = _React$useState4[0],
    setAnimation = _React$useState4[1];
  React.useEffect(() => {
    const animation = animateShowHide(() => {}, () => {});
    setAnimation(animation);
    animation.forward[0]();
  }, []);
  const onBack = () => {
    setStep(step - 1);
    animation.back[step - 1]();
  };
  const onForward = () => {
    animation.forward[step + 1]();
    setStep(step + 1);
  };
  return React.createElement("div", {
    className: "f-center bg-tur-100"
  }, React.createElement(Header, null), React.createElement("div", {
    className: "u-center main-content-constrained"
  }, React.createElement("h1", {
    className: "h1"
  }, "Animated Columns"), React.createElement(ColumnWrapper, null, React.createElement(ColumnFrame, null, React.createElement(Column, {
    id: "1"
  })), React.createElement(ColumnFrame, null, React.createElement(Column, {
    icon: step === 2 ? 'exclamation-sign' : undefined,
    id: "2"
  })), React.createElement(ColumnFrame, null, React.createElement(Column, {
    icon: step === 1 ? 'clock-simple' : undefined,
    id: "3"
  }))), React.createElement("button", {
    disabled: step === 0,
    onClick: onBack,
    type: "button"
  }, "\u2190"), React.createElement("button", {
    disabled: step >= (animation === null || animation === void 0 ? void 0 : animation.forward.length) - 1,
    onClick: onForward,
    type: "button"
  }, "\u2192"), React.createElement(FadeInSlideWrapper, null, React.createElement("div", null, "FadeInSlideWrapper"), React.createElement("div", null, "ello"), React.createElement("div", null, "llo"), React.createElement("div", null, "lo"), React.createElement("div", null, "o"), React.createElement("div", null, "Hello"), React.createElement("div", null, "Hell"))));
};
svs.playerRegistration.components.AnimatedColumns = AnimatedColumns;

 })(window);